module.exports = __webpack_public_path__ + "customFonts.a0b2dcebf08825c54f10fb0c9c4a6ea1.png";